import { render } from "./CheckoutPage.vue?vue&type=template&id=aa0e8ff2"
import script from "./CheckoutPage.vue?vue&type=script&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__